var map = {
	"./MasterStore.js": 1276,
	"./index.js": 680
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1275;


//////////////////
// WEBPACK FOOTER
// ./src/store/modules nonrecursive \.js$
// module id = 1275
// module chunks = 32